'use client';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ my?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;

  ${({ my }) =>
    my &&
    css`
      margin: ${my}px 0;
    `}
`;

export const Text = styled.p<{
  fontSize?: number;
  paddingTop?: number;
  paddingBottom?: number;
  isBold?: boolean;
}>`
  font-size: ${({ fontSize = 14 }) => fontSize + 'px'};
  padding-top: ${({ paddingTop = 0 }) => paddingTop + 'px'};
  padding-bottom: ${({ paddingBottom = 0 }) => paddingBottom + 'px'};
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
  text-align: center;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const LinkText = styled(Link)`
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  padding-left: 3px;
  color: inherit;
`;
